import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var fastIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.971 19.621a9 9 0 1 0 .124-11.394",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "m18.886 5.719 1.759-1.66 2.24 2.114-2 1.886M12.673 5V2.908l-.964-.964v-.901H16v.901l-.925.925V5",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.106 11.5H0V11a1 1 0 0 1 1-1h8.106v.5a1 1 0 0 1-1 1Zm1 3H1V14a1 1 0 0 1 1-1h8.106v.5a1 1 0 0 1-1 1Zm9.394-3.947-2.837 2.836-.354-.353a1 1 0 0 1 0-1.414l2.837-2.837.353.354a1 1 0 0 1 0 1.414ZM8.106 17.5H0V17a1 1 0 0 1 1-1h8.106v.5a1 1 0 0 1-1 1Z",
  fill: "currentColor",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "14",
  cy: "14",
  r: "2",
  stroke: "currentColor",
  strokeWidth: "1.5"
})));

export { fastIcon as default };
//# sourceMappingURL=fastIcon.js.map
